import * as React from 'react';

const Pen = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      {...props}
    >
      <path
        d='M14.9879 0.0380859L12.6221 2.42892L17.5879 7.39475L19.9537 5.00392L14.9879 0.0380859Z'
        fill='var(--colorIconPrimary)'
      />
      <path
        d='M5.24206 19.7495H0.275391V14.7828L10.3087 4.74951H13.4921L2.52539 15.7162V17.4995H4.30872L14.0587 7.74951H17.2421L5.24206 19.7495Z'
        fill='var(--colorIconPrimary)'
      />
    </svg>
  );
};
export default Pen;
